<div class="container-fluid page" *ngIf="!docDetails">
    <div class="d-flex page__box p-3 mt-2">&nbsp; Verification History </div>
    <div class="page__content shadow p-3" style="margin-top: -2rem;">

        <div>
            <mat-form-field>
                <mat-label>Traders</mat-label>
                <mat-select (selectionChange)="selectName($event)"  [(ngModel)]="selectedTrader">
                    <mat-option *ngFor = "let x of traderDataList"  [value]="x.traderId">
                         {{x.traderName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>

            <div class="mat-elevation-z8 position-relative" style="margin-top: 15px;">
                <mat-table #table [dataSource]="dataSource" >

                    <!-- Name Column -->
                    <ng-container matColumnDef="verifiedOn">
                        <mat-header-cell  *matHeaderCellDef>Verified On </mat-header-cell>
                        <mat-cell *matCellDef="let userDataList">{{userDataList.verifiedOn}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="verifiedBy">
                        <mat-header-cell  *matHeaderCellDef> Verified By </mat-header-cell>
                        <mat-cell *matCellDef="let userDataList">{{userDataList.verifiedBy}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <mat-header-cell  *matHeaderCellDef>Status</mat-header-cell>
                        <mat-cell *matCellDef="let userDataList">{{userDataList.status}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="comment">
                        <mat-header-cell  *matHeaderCellDef> Comment </mat-header-cell>
                        <mat-cell *matCellDef="let userDataList">{{userDataList.comment}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="document">
                        <mat-header-cell  *matHeaderCellDef> Document </mat-header-cell>
                        <mat-cell *matCellDef="let userDataList"  style="cursor: pointer;">
                            <a class="links" (click)="showDocument(userDataList)">View</a></mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
                <!-- <div>
              <mat-paginator [length]="length" [pageIndex]="pageIndex" (page)="getServerData($event)"
                [pageSizeOptions]="[10,20,50,100]" showFirstLastButtons aria-label="">
              </mat-paginator>
  
            </div> -->
            </div>
        </div>
    </div>

</div>

<div class="container-fluid page" *ngIf="docDetails">
    <div class="d-flex page__box p-3 mt-2"><img src="./assets/arrow_logo.png" class="arrow"
        (click)="docList()">&nbsp;&nbsp;Document Verification</div>
    <div class="galleryImgScroll">
      <div id="col-1">
        <div style="width:100%">
          <div>
            <gallery class="custom" id="basic-test" fluid [items]="items_find_url" style="width:60%;">
            </gallery>
          </div>
        </div>
        <div *ngIf="filetypereal == '.pdf'">
          <div *ngFor="let video of pdfprint">
            <div class='iframe-parent'>
            </div>
          </div>
        </div>
      </div>
  
      <div>
        <div id="col-2">
          <mat-card style="border-radius: 21px;">
            <div class="col-md-12 row" style="justify-content: space-between !important">
              <div class="col-md-4 document">
                <!-- <h5>Document Details</h5> -->
                <p class="name_field">
                  <!--<b>Person Name</b>    :--> {{personName == null ? 'NA':personName}}
                </p>
                <p style="font-size:17px !important;font-weight:600;">
                  <!--<b>Role</b>           :--> {{companyname == null ? 'company name not available':companyname}}
                </p>
                <p>
                  {{states == null ? 'State not available':states}},{{district == null ? 'District not
                  available':district}}</p>
  
              </div>
              <div class="col-md-4" style="margin-top: 30px;">
                <!-- <p><b>Role</b>           : <b>{{companyname == null ? 'NA':companyname}}</b></p> -->
                <p>
                  {{phoneNo == null ? 'Phone no not available':phoneNo}}
                </p>
                <p>
                  {{emailId == null ? 'Email id not available':emailId}}
                </p>
                <!-- <p><b>Mandi</b>          : <b>{{mandi == null ? 'Email Id not available':mandi}}</b></p> -->
              </div>
              <div class="col-md-4">
                 <p>
                 {{documentStatus == 'InProgress' ? 'verification
                  pending':documentStatus}}
                </p>
                <p *ngIf="documentStatus == 'Rejected'">Reason for Rejection: {{rejectedReason}}</p>
                <mat-icon *ngIf="documentStatus == 'Verified'" class="maticonverify">check_circle</mat-icon> 
  
                <div *ngIf="restrictbutton">
                  <div
                    *ngIf="documentStatus == 'InProgress' || documentStatus == 'Rejected' || documentStatus == 'Pending Verification'">
                    <button type="button" style="width: 50%; border-color: #0d6efd; background-color: #2b50a0; "
                      (click)="Updateverified('verify')" class="btn btn-primary">Approve</button>
                  </div>
                  <!-- <div style="margin-top: 8px;"> -->
                  <div
                    *ngIf="documentStatus == 'InProgress' || documentStatus == 'Verified' || documentStatus == 'Pending Verification'">
                    <button type="button" (click)="rejectionInput('open')"
                      class="btn btn-primary rejbutt">Reject</button>&nbsp;
                  </div>
                  <div>
                    <form>
  
                      <mat-form-field style="width: 80%;" *ngIf="showinput">
                        <mat-label>reason for rejection</mat-label>
                        <mat-select [(ngModel)]="ReasonForReject" name="rejection">
                          <mat-option *ngFor="let reject of resonForReject" [value]="reject.viewValue">
                            {{reject.viewValue}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </form>
                  </div>
  
                  <div *ngIf="ReasonForReject==='Others'">
  
                    <textarea type="text" placeholder="Mention a reason" [(ngModel)]="otherReasonText" maxlength="100"
                      rows="3" style="width: 80%;"></textarea>
  
                  </div>
                  <button *ngIf="showinput" type="button" style="background-color: #9CC43C;
                    border-color: #0d6efd;" (click)="Updateverified('reject')" class="btn btn-primary">Submit</button>
                  &nbsp;
                  <button *ngIf="otherReason" (click)="rejectionInput('close')" class="btn btn-primary" type="button"
                    style="background-color: #9CC43C;
                    border-color: #0d6efd;"> Cancel</button>
                </div>
              </div>
  
            </div>
          </mat-card>
  
        </div>
      </div>
  
    </div>
    <!-- <app-document-history [userDataItem]=userDataList></app-document-history> -->
  </div>